// Copyright 2023, Avation Medical. All rights reserved.
// 
// This code is proprietary and confidential information of Avation Medical. Any use, reproduction, modification
// or distribution of the code without the express prior written consent of Avation Medical is strictly prohibited.

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ConfirmAccessCodeComponent } from './confirm-access-code/confirm-access-code.component';
import { LoginComponent } from './login.component';
import { TOSAgreementComponent } from './tos-agreement/tos-agreement.component';
import { AuthService } from 'src/app/core/services/auth.service';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [AuthService],
  },
  {
    path: 'confirm-access/:username',
    component: ConfirmAccessCodeComponent
  },
  {
    path: 'tos',
    component: TOSAgreementComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule { }
